import { createI18n } from 'vue-i18n'

import en from './en.json'
import de from './de.json'

const defaultLocale = 'en'

const i18n = createI18n({
    locale: defaultLocale, // Default locale
    fallbackLocale: 'en',
    messages: {
      en,
      de,
    },
    datetimeFormats: {
      'en': {
        short: {
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric'
        },
        shortSeconds: {
          month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric'
        },
        shortAll: {
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric'
        },
        long: {
          year: 'numeric', month: 'short', day: 'numeric',
          weekday: 'short', hour: 'numeric', minute: 'numeric'
        },
        longSeconds: {
          year: 'numeric', month: 'short', day: 'numeric',
          weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
      },
      'de': {
        short: {
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric'
        },
        shortSeconds: {
          month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric'
        },
        shortAll: {
          year: 'numeric', month: 'numeric', day: 'numeric',
          hour: 'numeric', minute: 'numeric', second: 'numeric'
        },
        long: {
          year: 'numeric', month: 'short', day: 'numeric',
          weekday: 'short', hour: 'numeric', minute: 'numeric'
        },
        longSeconds: {
          year: 'numeric', month: 'short', day: 'numeric',
          weekday: 'short', hour: 'numeric', minute: 'numeric', second: 'numeric'
        }
      }
    }
  });
  
  export { i18n, defaultLocale };
